import { HttpClient } from '@angular/common/http'
import { EMPTY, tap } from 'rxjs'
import { inject, provideAppInitializer } from '@angular/core'
import { Store } from '@ngrx/store'
import { catchError, filter, take } from 'rxjs/operators'
import { setUser } from './store/auth.action'
import { IUser } from './store/auth.state'
import { selectUser } from './store/auth.selector'
import { environment } from '../environments/environment'
import { CookieService } from 'ngx-cookie-service'

const url = `${environment.apiUrl}uaa/api/user/get-my-info`

function initializeAppFactory(httpClient: HttpClient,
                              store: Store,
                              cookieService: CookieService): () => Promise<any> {
	return () => {
		return new Promise(resolve => {
			const cookie = cookieService.get('hasToken')
			if (cookie === 'false' || !cookie) {
				resolve(true)
				return
			}

			// Dispatch action to load user
			httpClient.get(url).pipe(
				tap((res: any) => {
					if (!res) {
						cookieService.set('hasToken', 'false')
						return
					}

					const user = {
						...res,
						// userType: res.userType.length > 1 ? res.userType[0]: res.userType.join(),
						userType: res.userType
						// userTypeList: res.userType,
					} as IUser

					store.dispatch(setUser({user: user}))
					cookieService.set('hasToken', 'true')
				}),
				catchError(() => {
					cookieService.set('hasToken', 'false')
					resolve(true)
					return EMPTY
				})
			).subscribe()

			// Wait for user to be in store before resolving
			store.select(selectUser).pipe(
				filter(user => !!user),
				take(1)
			).subscribe(() => {
				resolve(true)
			})
		})
	}
}

export const initializeApp = provideAppInitializer(() => {
	const initializerFn = (initializeAppFactory)(inject(HttpClient), inject(Store), inject(CookieService))
	return initializerFn()
})